module.exports = {"540425100":"竹瓦根镇","540425101":"上察隅镇","540425102":"下察隅镇","540425200":"察瓦龙乡","540425201":"古拉乡","540425202":"古玉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540425.json
// module id = 2721
// module chunks = 0